import type Quill from 'quill/core';
import getContentRectForBoundaries from './getContentRectForBoundaries';
import { getRangeSaver } from '../../editor/RangeSaver';
import getRangeBoundaries from '../../editor/utils/getRangeBoundaries';

const getContentRectForCurrentSelection = (quill: Quill) => {
  const boundaries = getRangeBoundaries(quill, getRangeSaver(quill).getLast());
  if (!boundaries?.length) return null;

  return getContentRectForBoundaries(boundaries);
};

export default getContentRectForCurrentSelection;
